import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Grid, Paper, withStyles, Button, List, ListItem, ListItemText, Avatar, ListItemSecondaryAction, Chip, CircularProgress } from '@material-ui/core';
import { LinkContainer } from 'react-router-bootstrap';
import { jobsActionCreators } from '../../actions/jobsActionCreators';
import { getBlobFromBase64 } from '../../helpers';
import Moment from 'react-moment';
import FilterCategoriesForm from './forms/FilterCategoriesForm';
import { CalendarToday } from '@material-ui/icons';
import { withTranslation } from 'react-i18next'; // Import withTranslation

const styles = theme => ({
    root: {
        flexGrow: 1,
        textAlign: 'center',
    },
    paper: {
        padding: theme.spacing.unit * 2,
        overflow: 'hidden',
        textAlign: 'justify',
    },
    title: {
        fontSize: '1.2rem',
    },
    coverImage: {
        width: '100%',
    },
    socialShare: {
        color: theme.palette.primary.main,
    },
    contestBackground: {
        backgroundColor: 'green',
        color: '#fff'
    },
    listItem: {
        [theme.breakpoints.down('xs')]: {
            flexDirection: 'column',
            alignItems: 'stretch'
        }
    }
});

class ContestsList extends Component {
    constructor(props) {
        super(props);

        this.handleSubmit = this.handleSubmit.bind(this);
    }

    componentWillMount() {
        this.props.requestContestsOffers();
        this.props.getCategories();
    }

    handleSubmit() {
        this.props.filterContestsOffers();
    }

    render() {
        const { classes, t } = this.props; // Use t for translations
        const jobs = this.props.jobOffers;
        const categories = this.props.categories;
        const employer = this.props.employer;

        return (this.props.isLoading ? <div><CircularProgress size={100} /></div> :
            <div className={classes.root}>
                <h2>{t('contests')}</h2> {/* Translated heading */}
                <Grid container spacing={24}>
                    <Grid item xs={12} align="right">
                        {/* Additional content can go here */}
                    </Grid>
                    <Grid item xs={12}>
                        <Paper className={classes.paper}>
                            <List dense>
                                {jobs && jobs.length > 0 ? jobs.map((currentJob, i) =>
                                    <LinkContainer key={currentJob.id} to={`/job/details/${currentJob.id}`} exact>
                                        <ListItem button className={classes.listItem}>
                                            <Chip label={t('contest')} className={classes.contestBackground} /> {/* Translated chip label */}
                                            <ListItemText primary={currentJob.title} className={classes.title} />
                                            <Chip
                                                icon={<CalendarToday />}
                                                label={<Moment format="DD.MM.YYYY" withTitle>{currentJob.expirationDate}</Moment>}
                                            />
                                        </ListItem>
                                    </LinkContainer>)
                                    : <ListItem>
                                        {t('noContestsAvailable')} {/* Translated text */}
                                    </ListItem>}
                            </List>
                        </Paper>
                    </Grid>
                </Grid>
            </div>
        );
    }
}

// Wrap the component with withTranslation HOC
export default withTranslation()(
    withStyles(styles)(
        connect(
            state => state.jobs,
            dispatch => bindActionCreators(jobsActionCreators, dispatch)
        )(ContestsList)
    )
);

//import React, { Component } from 'react';
//import { connect } from 'react-redux';
//import { bindActionCreators } from 'redux';
//import { Grid, Paper, withStyles, Button, List, ListItem, ListItemText, Avatar, ListItemSecondaryAction,Chip, CircularProgress } from '@material-ui/core';
//import { LinkContainer } from 'react-router-bootstrap';
//import { jobsActionCreators } from '../../actions/jobsActionCreators';
//import { getBlobFromBase64 } from '../../helpers';
//import Moment from 'react-moment';
//import FilterCategoriesForm from './forms/FilterCategoriesForm';
//import { CalendarToday } from '@material-ui/icons';


//const styles = theme => ({
//    root: {
//        flexGrow: 1,
//        textAlign: 'center',
//    },
//    paper: {
//        padding: theme.spacing.unit * 2,
//        overflow: 'hidden',
//        textAlign: 'justify',
//    },
//    title: {
//        fontSize: '1.2rem',
//    },
//    coverImage: {
//        width: '100%',
//    },
//    socialShare: {
//        color: theme.palette.primary.main,
//    },
//    contestBackground: {
//        backgroundColor: 'green',
//        color: '#fff'
//    },
//    listItem: {
//        [theme.breakpoints.down('xs')]: {
//            flexDirection: 'column',
//            alignItems: 'stretch'
//        }
//    }
//});

//class ContestsList extends Component {
//    constructor(props) {
//        super(props);

//        this.handleSubmit = this.handleSubmit.bind(this);
//    }

//    componentWillMount() {
//        this.props.requestContestsOffers();
//        this.props.getCategories();
//    }

//    handleSubmit() {
//        this.props.filterContestsOffers();
//    }

//    render() {
        
//        const { classes } = this.props;
//        const jobs = this.props.jobOffers;  
//        const categories = this.props.categories;
//        const employer = this.props.employer;

//        return (this.props.isLoading ? <div><CircularProgress size={100} /></div> : 
//            <div className={classes.root}>
//                <h2>Конкурси</h2>
//                <Grid container spacing={24}>  
//                    <Grid item xs={12} align="right">
                        
//                    </Grid>
//                    <Grid item xs={12}>                        
//                        <Paper className={classes.paper}>
//                            <List dense>
//                                {jobs && jobs.length > 0 ? jobs.map((currentJob, i) =>
//                                    <LinkContainer key={currentJob.id} to={`/job/details/${currentJob.id}`} exact>
//                                        <ListItem button className={classes.listItem}>
//                                            <Chip label="конкурс" className={classes.contestBackground} />
//                                            <ListItemText primary={currentJob.title} className={classes.title}/>
//                                            <Chip
//                                                icon={<CalendarToday />}
//                                                label={<Moment format="DD.MM.YYYY" withTitle>{currentJob.expirationDate}</Moment>}
//                                            />
//                                        </ListItem>
//                                    </LinkContainer>)
//                                    : <ListItem>
//                                        Няма налични обявления за конкурси
//                                    </ListItem>}
//                            </List>
//                        </Paper>
//                    </Grid>                   
//                </Grid>
//            </div>
//        )
//    }
//}

//export default withStyles(styles)(connect(
//    state => state.jobs,
//    dispatch => bindActionCreators(jobsActionCreators, dispatch)
//)(ContestsList));
